import { createFileRoute, redirect } from "@tanstack/react-router";

// Permanent redirect — canonical privacy page lives at /privacy.
export const Route = createFileRoute("/privacy-policy")({
  beforeLoad: () => {
    throw redirect({ to: "/privacy", statusCode: 301 });
  },
});
